export enum AMPLITUDE_EVENT {
	APPLICATION_CREATED = 'Application Created',
	APPLICATION_DELETED = 'Application Deleted',
	APPLICATION_MODIFIED = 'Application Modified',
	AUTOMATION_TYPE_CHANGED = 'automationTypeChanged',
	BULK_TAG_APPLIED = 'Bulk Tag Applied',
	DASHBOARD_CLICKED = 'dashboardClicked',
	DATA_DICTIONARY_RESULT_CLICKED = 'Data Dictionary Result Clicked',
	EMAIL_NOTIFICATION_PREFERENCE_UPDATED = 'Email Notifications Preference Updated',
	EMAIL_UPDATED = 'Email Updated',
	INITIATIVE_CREATED = 'Initiative Created',
	INITIATIVE_COMMENT_CREATED = 'Initiative Comment Created',
	INITIATIVE_DASHBOARD_VIEWED = 'Initiative Dashboard Viewed',
	INITIATIVE_DETAILS_VIEWED = 'Initiative Details Viewed',
	INITIATIVE_TASK_CREATED = 'Initiative Task Created',
	INITIATIVE_SCOPE_LINKED_TO_TASK = 'Initiative Scope Linked To Task',
	INITIATIVE_SCOPE_UNLINKED_FROM_TASK = 'Initiative Scope Unlinked From Task',
	INITIATIVE_TASK_DELETED = 'Intiative Task Deleted',
	ISSUES_VIEWED = 'Issues Viewed',
	JIRA_ISSUE_LINKED = 'Jira Issue Linked',
	JIRA_ISSUE_UNLINKED = 'Jira Issue Unlinked',
	LOGIN_EVENT = 'loginEvent',
	LOGS_VIEWED = 'Logs Viewed',
	NAME_UPDATED = 'Name Updated',
	NEW_SALESFORCE_ORGANIZATION_CLICKED = 'newOrganizationClicked',
	NEW_SALESFORCE_SANDBOX_CLICKED = 'Link New Salesforce Sandbox Clicked',
	NOTIFICATION_CLICKED = 'Notification Clicked Through',
	NOTIFICATION_DISMISSED = 'Notification Dismissed',
	NOTIFICATIONS_CLEARED = 'Notifications Cleared',
	ORGANIZATION_SWITCHED = 'organizationSwitched',
	OWNER_ASSIGNED = 'Owner Assigned',
	PACKAGE_TAGGING_TOGGLED = 'Package Tagging Toggled',
	PASSWORD_UPDATED = 'Password Updated',
	PERISCOPE_OPENED = 'cardOpened',
	PULSE_OBJECT_CHANGED = 'Pulse Objects Changed',
	SALESFORCE_LIGHTING_URL_PREFERENCE_UDPATED = 'SalesForce Lightning URL Preference Updated',
	SALESFORCE_URL_CLICKED = 'sfUrlClicked',
	SEARCH_MADE = 'Search Made',
	SEARCH_RESULT_CLICKED = 'Search Result Clicked',
	SCOPE_CHANGED = 'Scope Changed',
	SETTINGS_VIEWED = 'Settings Viewed',
	STATUS_CHANGED = 'Status Changed',
	SUGGESTION_ACCEPTED = 'Suggestion Accepted',
	SUGGESTION_GENERATED = 'Suggestion Generated',
	SYNC_STARTED = 'Sync Started',
	TAG_CREATED = 'Tag Created',
	TAG_DELETED = 'Tag Deleted',
	TAG_LINKED = 'tagLinked',
	TAG_UNLINKED = 'tagUnlinked',
	TAG_UPDATED = 'Tag Updated',
	TAGS_VIEWED = 'Configure Tags Viewed',
	TIMELINE_VIEWED = 'Timeline Viewed',
	USER_INVITED = 'User Invited',
	USER_INVITED_FROM_ONBOARDING = 'invitedUserFromOnboardingFlow',
	USER_PERMISSIONS_UPDATED = 'User Permissions Updated',
	USER_STATUS_UPDATED = 'User Status Updated',
	VIEW_DIFFERENCES_CLICKED = 'clickedViewDetailedDifferences'
}

export enum AMPLITUDE_PERISCOPE_EVENT_SOURCE {
	INITIATIVE_VIEW = 'Initiative View',
	ISSUES_VIEW = 'Issues View',
	DASHBOARD_VIEW = 'Dashboard View',
	MAIN_MENU = 'Main Menu',
	PERISCOPE_VIEW = 'Periscope View',
	TIMELINE_VIEW = 'Timeline View',
	DATA_ACCESS_VIEW = 'Data Access View',
	DATA_DICTIONARY_VIEW = 'Data Dictionary View'
}
